import LegalDoc from '../../components/LegalDoc';
import markdown from '../../content/legal/b2b-dpa.md?raw';

export default function DPAScreen() {
  return <LegalDoc markdown={markdown} title="Data Processing Agreement" />;
}
